import { COMMON_PROPERTIES, RENTAL_PERIOD_SELECTED_OPTIONS } from './constants';
import { getTermValue, TJsonQueryKeys } from '../../../../JsonQuery';
import { IJsonQuery } from '../../../../api-models/common/json_query';

function isCommonPropertiesSelected(jsonQuery: IJsonQuery) {
  return (Object.keys(jsonQuery) as TJsonQueryKeys[]).some(property => !COMMON_PROPERTIES.includes(property));
}

function isRentalPeriodSelected(jsonQuery: IJsonQuery) {
  const rentalPeriod = getTermValue('for_day')(jsonQuery);

  return rentalPeriod !== null && RENTAL_PERIOD_SELECTED_OPTIONS.includes(rentalPeriod);
}

export function isAdvancedFiltersSelected(jsonQuery: IJsonQuery): boolean {
  return isCommonPropertiesSelected(jsonQuery) || isRentalPeriodSelected(jsonQuery);
}
